import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { Command, CommandInput } from './command';

export interface SearchBarProps {
  onSearchText: (value: string) => void;
  placeholderText?: string;
  defaultValue?: string;
  debounceMs?: number;
}

function SearchBar({ onSearchText, placeholderText, defaultValue, debounceMs = 300 }: SearchBarProps) {
  const [inputValue, setInputValue] = useState(defaultValue || '');

  const [debounced] = useDebouncedCallback((value: string) => {
    onSearchText(value);
  }, debounceMs);

  useEffect(() => {
    setInputValue(defaultValue || '');
  }, [defaultValue]);

  return (
    <>
      <Command>
        <CommandInput
          placeholder={placeholderText || 'Suche'}
          value={inputValue}
          onValueChange={(value) => {
            setInputValue(value);
            debounced(value);
          }}
          className="box-border h-8 rounded-xl border-neutral-alpha-5"
        />
      </Command>
    </>
  );
}

export default SearchBar;
